import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Delivery, Search, Customer, CustomerType, CrudService, ListItem, Page, MessageService } from 'orv-ui-base-lib';
import { ClassType } from 'class-transformer/ClassTransformer';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.scss']
})
export class AddTaskComponent implements OnInit {

  @Output() save: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();

  timeStruct: any;

  dispatchDate: number;

  delivery: Delivery;

  customerSearch: Search = new Search('customer');
  customerEntityClass: ClassType<Customer> = Customer;
  numprcls: number;
  listitems: ListItem[];
  list = 'delivery.mode';

  constructor(private listService: CrudService<ListItem>,
    private messageService: MessageService,
    private translateService: TranslateService) {
    this.customerSearch.addSimpleFilter('ctype', CustomerType.delivery);
    this.delivery = new Delivery();
  }

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    const search = new Search('listitem join list on list.id = listitem.lid');
    search.addSimpleFilter('list.slug', this.list);

    const page = new Page(100000);
    page.setPageNumber(0);

    this.listService.searchEntities(ListItem, 'listitem', search, page).subscribe(
      results => {
        this.listitems = results;
      },
      ({ error }) => {
        console.log(error);
      }
    );
  }

  onTimeChange(time: any) {
    if (time && time.hour && time.minute >= 0 && this.delivery.deliverby) {
      const d = new Date(this.delivery.deliverby);
      d.setHours(time.hour);
      d.setMinutes(time.minute);
      this.delivery.deliverby = d.getTime();

      const date = new Date();


    }
  }

  submit() {
    if (this.delivery.deliverby < this.dispatchDate) {
      this.messageService.sendWarn(this.translateService.instant('labels.delivery-time-error'),
        this.translateService.instant('labels.delivery'));
      return;
    }
    this.save.emit(this.delivery);
  }
}
